import { PERSPECTIVE_COLORS } from 'lib/constants';

class PerspectiveCreationUI {

  setCanvas(canvas) {
    this.canvas = canvas;
  }

  clearSelectedResultNode() {
    $('.new-perspective-result').removeClass('new-perspective-result');
  }

  highlightSelectedResultNode(selectedNode) {
    this.clearSelectedResultNode();
    if (!selectedNode) {
      return;
    }
    this.canvas.nodeTags[selectedNode.id].refs.container.classList.add('new-perspective-result');
  }

  findNextUnusedColor() {
    const usedColors = store.getUsedPerspectiveColors();
    const usedColorsLookup = {};
    for (const c of usedColors) {
      usedColorsLookup[c] = 1;
    }

    let newColor;
    for (const c of PERSPECTIVE_COLORS) {
      if (!usedColorsLookup[c]) {
        newColor = c;
        break;
      }
    }

    // if we used them all already, choose a random color
    if (!newColor) {
      newColor = PERSPECTIVE_COLORS[Math.floor(Math.random() * PERSPECTIVE_COLORS.length)];
    }

    return newColor;
  }
}
const pcui = new PerspectiveCreationUI();

export {PerspectiveCreationUI, pcui };



// WEBPACK FOOTER //
// ./starling/src/lib/perspective-creation-ui.js